type Options = {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export function getFormattedAvatarUrl(allData: any, prefix = '', options: Options = { size: 'sm' }) {
  if (!allData) return ''

  const newPrefix = prefix === '' ? '' : `${prefix}_`

  const pathnameExtension = `${newPrefix}avatar_extension`
  const pathnameId = `${newPrefix}avatar_id`
  const pathnamePublicUrl = `${newPrefix}avatar_url`
  const pathnameVariations = `${newPrefix}avatar_variations`

  const data = {
    extension: allData[pathnameExtension] || 'avatar',
    id: allData[pathnameId],
    publicUrl: allData[pathnamePublicUrl],
    variations: allData[pathnameVariations],
  }

  if (!data.publicUrl) return ''

  const extensionRegex = new RegExp(`\\.${data.extension}$`)

  return data.publicUrl.replace(extensionRegex, `-${options.size}.${data.extension}`)
}
